/**
 * Apply a discount code from the cart page or drawer before Shopify checkout.
 */
(function () {
  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function setMessage(box, text, isError) {
    var message = box.querySelector('[data-cart-discount-message]');
    if (!message) return;
    if (!text) {
      message.hidden = true;
      message.textContent = '';
      message.classList.remove('cart-discount__message--error');
      return;
    }
    message.hidden = false;
    message.textContent = text;
    message.classList.toggle('cart-discount__message--error', !!isError);
  }

  function bind(box) {
    if (box.dataset.discountBound) return;
    box.dataset.discountBound = '1';

    var form = box.querySelector('[data-cart-discount-form]');
    if (!form) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var input = form.querySelector('input[name="discount"]');
      var button = form.querySelector('button[type="submit"]');
      var code = (input && input.value ? input.value : '').trim();

      if (!code) {
        setMessage(box, 'Enter a discount code.', true);
        if (input) input.focus();
        return;
      }

      setMessage(box, '');
      if (button) button.disabled = true;

      fetch(rootUrl() + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error((result.data && result.data.description) || 'Could not apply that code.');
          }

          var codes = result.data.discount_codes || [];
          var match = codes.find(function (entry) {
            return (entry.code || '').toLowerCase() === code.toLowerCase();
          });

          if (match && match.applicable === false) {
            setMessage(box, 'That code does not apply to this cart.', true);
            if (button) button.disabled = false;
            return;
          }

          window.location.reload();
        })
        .catch(function (error) {
          setMessage(box, error.message || 'Could not apply that code.', true);
          if (button) button.disabled = false;
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-cart-discount]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
